exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-card--material-chart .v-card--material__header .ct-label{color:inherit;opacity:.7;font-size:.975rem;font-weight:100}.v-card--material-chart .v-card--material__header .ct-grid{stroke:hsla(0,0%,100%,.2)}.v-card--material-chart .v-card--material__header .ct-series-a .ct-bar,.v-card--material-chart .v-card--material__header .ct-series-a .ct-line,.v-card--material-chart .v-card--material__header .ct-series-a .ct-point,.v-card--material-chart .v-card--material__header .ct-series-a .ct-slice-donut{stroke:hsla(0,0%,100%,.8)}.v-card--material-chart .v-card--material__header .ct-series-a .ct-area,.v-card--material-chart .v-card--material__header .ct-series-a .ct-slice-pie{fill:hsla(0,0%,100%,.4)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-77e90672","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./VueSrc/Common/Components/materialcomponents/components/material/ChartCard.vue
// module id = 1508
// module chunks = 0